<template>
    <span>
        <el-date-picker class="filterItem-value" v-if="showInput"
                v-model="filterItem.value[0]"
                type="date"
                placeholder="选择一天"
                />
        <el-date-picker class="filterItem-value" v-if="showBetween"
            v-model="filterItem.value"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
        />
    </span>
</template>

<style>
    
</style>

<script>
    import baseFilter from "../../BaseFilter"

    export default {
        name:"DateFieldFilter",
        mixins:[baseFilter]
    }
</script>